export default __webpack_public_path__ + "static/media/docker-mark-blue.ef2e385e.svg";